












import PopupEpisode2 from '@/views/templates/tenugui/PopupEpisode2.vue'

export default
  components: {
    PopupEpisode2
  }

  data: () ->
    message: [
      '知恵とアイデアで完成した、伝統的だけど新しい私たちのてぬぐい。<br>ぜひ、ご自身のライフスタイルに合わせて、ご利用ください！'
    ]

  methods: {
    closePopup: () ->
      @$emit('closePopup')
    add_point: (point) ->
      @$emit('addPoint', point)
  }
